﻿import { Command, IframeView, InputTextView } from 'ckeditor5';

class OpenLinkPopupCommand extends Command {
    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        this.isEnabled = model.schema.checkAttributeInSelection(selection, 'linkHref');
        this.value = getSelectedLink(this.editor);
    }

    execute() {
        const editor = this.editor;
        const { t } = editor.locale;
        const dialog = editor.plugins.get('Dialog');
        const statisticLinkFrame = new IframeView(editor.locale);

        statisticLinkFrame.set({
            label: t('Add statistic link'),
            tooltip: true,
            withText: false
        });

        statisticLinkFrame.render();

        statisticLinkFrame.element.style.width = '550px';
        statisticLinkFrame.element.style.height = '650px';
        statisticLinkFrame.element.style.margin = '5px 15px';

        statisticLinkFrame.element.removeAttribute('sandbox');

        var isCentralSection = parent.location.href.toLowerCase().indexOf("centralsection/") > -1;
        var oLink = getSelectedLink(editor);
        var selLink;
        var selText;
        var isEditing = false;
        var imageSelected = checkImageSelected(editor);

        if (oLink) {
            selLink = oLink.url;
            selText = oLink.text;
            isEditing = true;
        }
        else {
            try {
                selText = getSelectedText(editor);
                if (imageSelected) {
                    selText = t('PicDefaultText');
                }
                else if (selText != '') {
                    selText = selText.substring(0, 255);
                }
            }
            catch (e) {
                selText = t('PicDefaultText');
            }
        }

        if (selText != '' || isEditing) {
            //currentSectionId and currentSectionDefinitionFieldId are defined globally in EditorField.js
            if (isCentralSection) {
                var url = new URL(window.location.href);

                currentSectionId = url.searchParams.get("sectionGuid");
                currentSectionDefinitionFieldId = editor.config.get('StatisticLink.FieldId');
            }

            var editLinkParams = new URL(parent.location.href).searchParams;
            editLinkParams.append("ForEditor", "true");
            editLinkParams.append("EditorName", editor.name);
            editLinkParams.append("SelectedLink", selLink);
            editLinkParams.append("SelectedText", encodeURIComponent((selText || '').replace(/(\r\n|\n|\r)/gm, "")));
            editLinkParams.append("ForImage", imageSelected);
            editLinkParams.append("SectionId", currentSectionId || editor.config.get('StatisticLink.SectionId'));
            editLinkParams.append("FieldId", currentSectionDefinitionFieldId || editor.config.get('StatisticLink.FieldId'));

            if (isCentralSection) {
                editLinkParams.append("centralSection", "true");
                editLinkParams.append("restrictLinkTypes", restrictLinkTypes);
            }

            if (parent != window) {
                var queryParams = new URL(window.location).searchParams;
                queryParams.forEach(function (value, key) {
                    editLinkParams.set(key, value);
                });
            }

            var iframePath = "/Dynamix/App#/Controls/EditLink?" + editLinkParams.toString();
            statisticLinkFrame.element.src = iframePath;

            function blockBlur(eventInfo) {
                eventInfo.stop();
            }

            // block/stop blur event to avoid closing campaign editor when switching tabs in placeholder chooser
            editor.on('blur', blockBlur, { priority: 'highest' });

            // "dummy" textbox to set focus to (to avoid focus on close button)
            let focusElement = new InputTextView();
            focusElement.set({ tabIndex: -1, withText: false, id: 'hidden-focus-element' });

            function close() {
                dialog.hide();
                editor.editing.view.focus();
            }

            let insertLink = (evt) => {
                InsertLinkForEditor(this.editor, evt.detail.url, getSelectedLink(this.editor)?.url);
                close();
                window.removeEventListener('StatisticLinkPlugin_AddStatisticLink', insertLink);
            }

            window.addEventListener('StatisticLinkPlugin_AddStatisticLink', insertLink);

            window.addEventListener('StatisticLinkPlugin_Close', close);

            dialog.show({
                isModal: true,
                title: t('Add statistic link'),
                content: [
                    focusElement,
                    statisticLinkFrame
                ],
                className: 'placeholder-chooser-dialog',
                onHide() {
                    // unregister events when closing the dialog
                    editor.off('blur', blockBlur);
                    window.removeEventListener('StatisticLinkPlugin_AddStatisticLink',insertLink);

                    window.removeEventListener('StatisticLinkPlugin_Cancel', close);
                }
            });
        }
    }
}

function getSelectedText(editor) {
    try {
        var range = editor.model.document.selection.getFirstRange();
        return [...range.getItems()].where(r => r.data).select(s => s.data).join('');
    }
    catch (e) {
        return null;
    }
}

function getSelectedLink(editor) {
    try {
        var range = editor.model.document.selection.getFirstRange();
        for (var value of range.getWalker()) {
            if (value.type === 'text' && value.item.hasAttribute('linkHref')) {
                return { url: value.item.getAttribute('linkHref'), text: value.item.data };
            }
            else if (value.item && value.item.name === 'imageInline' && value.item.hasAttribute('linkHref')) {
                return { url: value.item.getAttribute('linkHref'), text: '' };
            }
        }

        var position = editor.model.document.selection.getFirstPosition();
        if (position && position.textNode && position.textNode.hasAttribute('linkHref')) {
            return { url: position.textNode.getAttribute('linkHref'), text: position.textNode.data };
        }

        return null;
    }
    catch (e) {
        return null;
    }
}

function checkImageSelected(editor) {
    try {
        var range = editor.model.document.selection.getFirstRange();
        for (var value of range.getWalker()) {
            if (value.item && value.item.name === 'imageInline') {
                return true;
            }
        }
    }
    catch (e) {
        return false;
    }
}

function InsertLinkForEditor(editor, url, urlToReplace) {
    var range = editor.model.document.selection.getFirstRange();
    var position = editor.model.document.selection.getFirstPosition();
    editor.model.change(writer => {
        if (urlToReplace) {
            if (range.start.index !== range.end.index) {
                for (var value of range.getWalker()) {
                    if ((value.type === 'text' || value.type === 'softBreak' || (value.item && value.item.name === 'imageInline')) && value.item.hasAttribute('linkHref') && value.item.getAttribute('linkHref') === urlToReplace) {
                        writer.setAttribute('linkHref', url, value.item);
                    }
                }
            }
            else if (position && position.textNode && position.textNode.hasAttribute('linkHref') && position.textNode.getAttribute('linkHref') === urlToReplace) {
                writer.setAttribute('linkHref', url, position.textNode);
            }

        }
        else {
            writer.setAttribute('linkHref', url, range);
            if (position && position.textNode && position.textNode.hasAttribute('linkHref')) {
                writer.setAttribute('linkHref', url, position.textNode);
            }
        }
    });
}

export { OpenLinkPopupCommand, getSelectedLink };